import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Col, Row} from 'reactstrap';

const PopupImageComponent = (props) => {
 return (
     <Row>
        <Col>
            <Image src={props.icon} alt="icon" className="popup-component-image" />
        </Col>
     </Row>
 )
}

export default PopupImageComponent;